module.exports = __webpack_public_path__ + "static/img/17一种印花机的加浆装置.ebc6033a.jpg";